import { Button, DatePicker, Form, Input, Select } from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { instance } from "utils/axios";
import CustomerHistory from "../customer/CustomerHistory";

function CustomerForm({ form }) {
  const [loading, setLoading] = useState(false);
  const [isNotFount, setIsNotFound] = useState(false);
   const [openHistory, setOpenHistory] = useState(false);
     const [customerId, setCustomerId] = useState(null);
  useEffect(() => {
    let bookingId = form.getFieldValue(["bookingData", "preBookingId"]);
    let regno = form.getFieldValue(["customerData", "regno"]);
    if (!regno && bookingId) {
      getPreBookingById();
    }
  }, [form.getFieldValue(["bookingData", "preBookingId"])]);
  const handleRegChange = (e) => {
    if (e.target.value.length === 10) {
      getPreBooking();
    } else {
      form.setFieldValue(["customerData", "firstname"], null);
      form.setFieldValue(["customerData", "lastname"], null);
      form.setFieldValue(["customerData", "age"], null);
      form.setFieldValue(["customerData", "gender"], null);
      form.setFieldValue(["bookingData", "preBookingId"], null);
      form.setFieldValue(["bookingData", "insurance"], null);
      form.setFieldValue(["bookingData", "isCe"], null);
      form.setFieldValue(["bookingData", "isEnglishResponse"], null);
      form.setFieldValue(["bookingData", "isAns"], null);
      form.setFieldValue(["bookingData", "onlyCe"], null);
      form.setFieldValue(["bookingData", "addition"], null);
      form.setFieldValue(["bookingData", "urgent"], null);
      form.setFieldValue(["bookingData", "bookingservices"], null);
      // form.setFieldValue(["bookingData"], null);
    }
  };

  const getCustomerInfo = () => {
    setLoading(true);
    instance({
      method: "get",
      url: `customer/find/${form.getFieldValue(["customerData", "regno"])}`,
    })
      .then((res) => {
        if (res.data) {
          setIsNotFound(false);
          form.setFieldValue("customerData", {
            ...res.data,
          });
        } else {
          form.setFieldValue(["customerData", "id"], 0);
          setIsNotFound(true);
        }
      })
      .catch((err) => {})
      .then(() => setLoading(false));
  };

  const getPreBooking = () => {
    setLoading(true);
    instance({
      method: "get",
      url: `prebooking/find/${form.getFieldValue([
        "customerData",
        "regno",
      ])}?hospitalId=${form.getFieldValue(["bookingData", "hospitalId"])}
      &servicetype=${form.getFieldValue(["bookingData", "servicetypeid"])}`,
    })
      .then((res) => {
        if (res.data) {
          setIsNotFound(false);
          setResponseBooking(res);
        } else {
          form.setFieldValue(["customerData", "id"], 0);
          setIsNotFound(true);
        }
      })
      .catch((err) => {})
      .then(() => setLoading(false));
  };
  const getPreBookingById = () => {
    setLoading(true);
    instance({
      method: "get",
      url: `prebooking/findbyid/${form.getFieldValue([
        "bookingData",
        "preBookingId",
      ])}`,
    })
      .then((res) => {
        if (res.data) {
          setIsNotFound(false);
          setResponseBooking(res);
        } else {
          form.setFieldValue(["customerData", "id"], 0);
          setIsNotFound(true);
        }
      })
      .catch((err) => {})
      .then(() => setLoading(false));
  };
  const setResponseBooking = (res) => {
  
    form.setFieldValue("customerData", {
      ...res.data.customer,
    });

    form.setFieldValue(
      ["bookingData", "preBookingId"],
      res.data.bookingData.preBookingId
    );

    form.setFieldValue(["bookingData", "isCe"], res.data.bookingData.isCe);
    form.setFieldValue(
      ["bookingData", "isEnglishResponse"],
      res.data.bookingData.isEnglishResponse
    );
    form.setFieldValue(
      ["bookingData", "hospitalId"],
      res.data.bookingData.hospitalId
    );
    form.setFieldValue(["bookingData", "isAns"], res.data.bookingData.isAns);
    form.setFieldValue(["bookingData", "onlyCe"], res.data.bookingData.onlyCe);
    form.setFieldValue(
      ["bookingData", "addition"],
      res.data.bookingData.addition
    );  
    form.setFieldValue(
      ["bookingData", "answerPhone"],
      res.data.bookingData.answerPhone
    );
    form.setFieldValue(
      ["bookingData", "insurance"],
      res.data.bookingData.insurance
    );
    form.setFieldValue(
      ["bookingData", "servicetypeid"],
      res.data.bookingData.servicetypeid
    );
    form.setFieldValue(["bookingData", "urgent"], res.data.bookingData.urgent);
    form.setFieldValue(
      ["bookingData", "bookingservices"],
      res.data.bookingData.bookingservices
    );
  };
  return (
    <>
      <Form.Item className="col-span-12 mb-0">
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          <Form.Item
            className="mb-0 col-span-12 md:col-span-6"
            label="Үйлчлүүлэгч"
          >
            <div className="flex">
              <Form.Item
                name={["customerData", "regno"]}
                className="mb-0 flex-1"
              >
                <Input
                  placeholder="Регистрийн дугаар оруулах"
                  onChange={handleRegChange}
                />
              </Form.Item>
              <Form.Item className="mb-0 ml-1">
                <Button onClick={getPreBooking}>Шалгах</Button>
                {/* <Button onClick={getPreBooking}>Цаг захиалгаас</Button> */}
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item name={["customerData", "id"]} noStyle></Form.Item>
          <Form.Item
            className="mb-0  col-span-12 md:col-span-6"
            label="Захиалгын дугаар"
          >
            <div className="flex">
              <Form.Item
                name={["bookingData", "preBookingId"]}
                className="mb-0 flex-1"
              >
                <Input placeholder="Захиалгын дугаар оруулах" />
              </Form.Item>
              <Form.Item className="mb-0 ml-1">
                <Button onClick={getPreBookingById}>Шалгах</Button>
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item name={["bookingData", "cbDateTime"]} noStyle></Form.Item>
          <Form.Item
            name={["customerData", "lastname"]}
            label="Овог"
            // rules={[{ required: true, message: "Овог оруулна уу!" }]}
            className="col-span-12 md:col-span-6 mb-0"
          >
            <Input disabled={!isNotFount} />
          </Form.Item>
          <Form.Item
            name={["customerData", "firstname"]}
            label="Нэр"
            rules={[{ required: true, message: "Нэр оруулна уу!" }]}
            className="col-span-12 md:col-span-6 mb-0"
          >
            <Input disabled={!isNotFount} />
          </Form.Item>

          <Form.Item
            name={["customerData", "gender"]}
            label="Хүйс"
            rules={[{ required: true, message: "Хүйс сонгоно уу!" }]}
            className="col-span-3 md:col-span-6 mb-0"
          >
            <Select
              options={[
                { label: "Эр", value: 1 },
                { label: "Эм", value: 0 },
              ]}
            />
          </Form.Item>
          <Form.Item
            name={["customerData", "age"]}
            label="Нас"
            rules={[{ required: true, message: "Нас оруулна уу!" }]}
            className="col-span-3 md:col-span-6 mb-0"
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name={["customerData", "hasAllergy"]}
            label="Харшилтай эсэх"
            // rules={[{ required: true, message: "Харшилтай эсэх сонгоно уу!" }]}
            className="col-span-6 md:col-span-6 mb-0"
          >
            <Select
              defaultValue={0}
              options={[
                { label: "Тийм", value: 1 },
                { label: "Үгүй", value: 0 },
              ]}
            />
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prev, cur) =>
              prev.customerData?.hasAllergy !== cur.customerData?.hasAllergy
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue(["customerData", "hasAllergy"]) === 1 ? (
                <Form.Item
                  label="Харшлын тайлбар"
                  name={["customerData", "allergyDescr"]}
                  rules={[
                    { required: true, message: "Харшлын тайлбар оруулна уу!" },
                  ]}
                  className="col-span-12 md:col-span-6 mb-0"
                >
                  <Input.TextArea className="w-full" />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item className="mb-0 ml-1" label="Түүх">
            <Button
              onClick={() => {
                setOpenHistory(true);
              }}
            >
              Харах
            </Button>
            {/* <Button onClick={getPreBooking}>Цаг захиалгаас</Button> */}
          </Form.Item>
          <CustomerHistory
            open={openHistory}
            onClose={() => setOpenHistory(false)} // Pass a function to handle closing
            customerId={form.getFieldValue(["customerData", "id"])}
          />
        </div>
      </Form.Item>
    </>
  );
}

export default CustomerForm;
